<template>
<!--  <a-card>-->
<!--    <div class="main-panel" style="height: 800px">-->

<!--      <div class="main-content-wrap">-->
<!--        <div class="main-operation-wrap">-->
<!--          <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }" :colon="false">-->
<!--            <a-row :gutter="20">-->
<!--              <a-col :span="6">-->
<!--                <a-form-model-item label="设备编码">-->
<!--                  <a-input v-model="equipmentCode" auto-complete="off" placeholder="设备编码" clearable-->
<!--                           style="width: 200px"></a-input>-->
<!--                </a-form-model-item>-->
<!--              </a-col>-->
<!--              &lt;!&ndash;              <a-col :span="6">&ndash;&gt;-->
<!--              &lt;!&ndash;                <a-form-model-item label="是否在公司">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <a-select v-model="isInCompany" filterable multiple :collapse-tags="true"&ndash;&gt;-->
<!--              &lt;!&ndash;                            placeholder="请输入运输方式" :clearable="true"&ndash;&gt;-->
<!--              &lt;!&ndash;                            style="width:200px">&ndash;&gt;-->
<!--              &lt;!&ndash;                    <a-select-option&ndash;&gt;-->
<!--              &lt;!&ndash;                      v-for="item in inCompanyOptions"&ndash;&gt;-->
<!--              &lt;!&ndash;                      :key="item.status"&ndash;&gt;-->
<!--              &lt;!&ndash;                      :label="item.label"&ndash;&gt;-->
<!--              &lt;!&ndash;                      :value="item.status">&ndash;&gt;-->
<!--              &lt;!&ndash;                      {{ item.label }}&ndash;&gt;-->
<!--              &lt;!&ndash;                    </a-select-option>&ndash;&gt;-->
<!--              &lt;!&ndash;                  </a-select>&ndash;&gt;-->
<!--              &lt;!&ndash;                </a-form-model-item>&ndash;&gt;-->
<!--              &lt;!&ndash;              </a-col>&ndash;&gt;-->
<!--              <a-col :span="6">-->
<!--                &lt;!&ndash;                <a-form-model-item label="search ">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <i class="el-icon-search" style="font-size: 20px" @click="search()"></i>&ndash;&gt;-->
<!--                &lt;!&ndash;                </a-form-model-item>&ndash;&gt;-->
<!--                &lt;!&ndash;                <a-form-model-item label="search " >&ndash;&gt;-->
<!--                &lt;!&ndash;                  <i class="el-icon-refresh-right" style="font-size: 20px"></i>&ndash;&gt;-->
<!--                &lt;!&ndash;                </a-form-model-item>&ndash;&gt;-->
<!--                <a-form-model-item>-->
<!--                  <a-button type="primary" plain icon="search" @click="search()">查询</a-button>-->
<!--                </a-form-model-item>-->
<!--              </a-col>-->
<!--            </a-row>-->
<!--          </a-form-model>-->
<!--        </div>-->

<!--        <a-row>-->
<!--          <a-col :span="24" class="table-style">-->
<!--            <a-table-->
<!--              class="receipt_table"-->
<!--              row-key="id"-->
<!--              :loading="table.loading"-->
<!--              :data-source="table.data"-->
<!--              :default-sort="table.sort"-->
<!--              :pagination="table.pagination"-->
<!--              @change="handleTableChange"-->
<!--              ref="table.dataRef">-->
<!--              <a-table-column-->
<!--                key="index"-->
<!--                data-index="index" title="#" align="center">-->
<!--                <template slot-scope="text, record, index">{{ index+1 }}</template>-->
<!--              </a-table-column>-->
<!--              <a-table-column-->
<!--                key="devId"-->
<!--                data-index="gpsLocation.devId" title="设备编码" align="center"></a-table-column>-->
<!--              <a-table-column-->
<!--                key="useStatus"-->
<!--                data-index="useStatus" title="使用状态" align="center">-->
<!--                <template slot-scope="record">-->
<!--                  {{ record === 0 ? "未使用" : record === 1 ? "使用中" : record === -1 ? "未知" : "回收中" }}-->
<!--                </template>-->
<!--              </a-table-column>-->
<!--              <a-table-column-->
<!--                key="locationStatus"-->
<!--                data-index="locationStatus" title="是否在仓库" align="center">-->
<!--                <template slot-scope="record">-->
<!--                  <span v-if="record!==-1" v-bind:style="record===0?{color:'#FA8539'}:{}">否</span>-->
<!--                  <a-switch v-if="record!==-1" size="small"-->
<!--                            :checked="record!==0"-->
<!--                            style="margin-bottom:5px"/>-->
<!--                  <span v-if="record!==-1" v-bind:style="record!==0?{color:'#FA8539'}:{}">是</span>-->
<!--                  <span v-if="record===-1" style="color: #FA8539">未知</span>-->
<!--                </template>-->
<!--              </a-table-column>-->
<!--              <a-table-column-->
<!--                key="lithium"-->
<!--                data-index="gpsStatus.lithium" title="电量" align="center">-->
<!--                <template slot-scope="record">-->
<!--                  <div style="border-radius: 5px" v-bind:style="record < 20?{'background-color': '#FAB6B6'}:{'background-color': '#B3E19D'}">{{ record }}%</div>-->
<!--                </template>-->
<!--              </a-table-column>-->
<!--              <a-table-column-->
<!--                key="gsmLevel"-->
<!--                data-index="gpsStatus.gsmLevel" title="信号强度" align="center"></a-table-column>-->
<!--              <a-table-column-->
<!--                key="humidity"-->
<!--                data-index="gpsStatus.humidity" title="湿度" align="center"></a-table-column>-->
<!--              <a-table-column-->
<!--                key="temperature"-->
<!--                data-index="gpsStatus.temperature" title="温度" align="center"></a-table-column>-->
<!--              <a-table-column-->
<!--                key="bizOrder.ifsNo"-->
<!--                data-index="bizOrder.ifsNo" title="最近绑定ifsNo" align="center"></a-table-column>-->
<!--              <div-->
<!--                slot="expandedRowRender"-->
<!--                slot-scope="record">-->
<!--                  最后定位 ： {{ record.gpsDevLocationDTO.gaoDeAddress.formatted_address }}-->
<!--              </div>-->
<!--              <a-table-column-->
<!--                key="createAt"-->
<!--                data-index="gpsLocation.createAt" title="签收时间" align="center">-->
<!--                <template slot-scope="record">-->
<!--                  <date-time-formatter :date-time="record"-->
<!--                                       formatter="YYYY-MM-DD HH:mm:ss"></date-time-formatter>-->
<!--                </template>-->
<!--              </a-table-column>-->
<!--              <a-table-column-->
<!--                key="updateAt"-->
<!--                data-index="gpsLocation.updateAt" title="最后定位时间" align="center">-->
<!--                <template slot-scope="record">-->
<!--                  <date-time-formatter :date-time="record"-->
<!--                                       formatter="YYYY-MM-DD HH:mm:ss"></date-time-formatter>-->
<!--                </template>-->
<!--              </a-table-column>-->
<!--            </a-table>-->
<!--          </a-col>-->
<!--        </a-row>-->
<!--      </div>-->
<!--    </div>-->
<!--  </a-card>-->
  <a-card>
    <div class="main-panel" style="height: 800px">

      <div class="main-content-wrap">
        <div class="main-operation-wrap">
          <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }" :colon="false">
            <a-row :gutter="20">
              <a-col :span="6">
                <a-form-model-item label="设备编码">
                  <a-input v-model="equipmentCode" auto-complete="off" placeholder="设备编码" clearable
                           style="width: 200px"></a-input>
                </a-form-model-item>
              </a-col>
              <!--              <a-col :span="6">-->
              <!--                <a-form-model-item label="是否在公司">-->
              <!--                  <a-select v-model="isInCompany" filterable multiple :collapse-tags="true"-->
              <!--                            placeholder="请输入运输方式" :clearable="true"-->
              <!--                            style="width:200px">-->
              <!--                    <a-select-option-->
              <!--                      v-for="item in inCompanyOptions"-->
              <!--                      :key="item.status"-->
              <!--                      :label="item.label"-->
              <!--                      :value="item.status">-->
              <!--                      {{ item.label }}-->
              <!--                    </a-select-option>-->
              <!--                  </a-select>-->
              <!--                </a-form-model-item>-->
              <!--              </a-col>-->
              <a-col :span="6">
                <!--                <a-form-model-item label="search ">-->
                <!--                  <i class="el-icon-search" style="font-size: 20px" @click="search()"></i>-->
                <!--                </a-form-model-item>-->
                <!--                <a-form-model-item label="search " >-->
                <!--                  <i class="el-icon-refresh-right" style="font-size: 20px"></i>-->
                <!--                </a-form-model-item>-->
                <a-form-model-item>
                  <a-button type="primary" plain icon="search" @click="search()">查询</a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>

        <a-row>
          <a-col :span="24" class="table-style">
            <a-table
              row-key="id"
              :loading="table.loading"
              :data-source="table.data"
              :default-sort="table.sort"
              :pagination="table.pagination"
              @change="handleTableChange"
              ref="table.dataRef">
              <a-table-column
                key="devId"
                align="center"
                data-index="gpsLocation.devId" title="设备编码" width="120"></a-table-column>
              <a-table-column
                key="lithium"
                align="center"
                data-index="gpsStatus.lithium" title="电量" width="120"></a-table-column>
              <a-table-column
                key="gsmLevel"
                align="center"
                data-index="gpsStatus.gsmLevel" title="信号强度" width="120"></a-table-column>
              <a-table-column
                key="humidity"
                align="center"
                data-index="gpsStatus.humidity" title="湿度" width="120"></a-table-column>
              <a-table-column
                key="temperature"
                align="center"
                data-index="gpsStatus.temperature" title="温度" width="120"></a-table-column>
              <!--              <a-table-column-->
              <!--                :sorter="true"-->
              <!--                key="buyStatus"-->
              <!--                data-index="buyStatus" title="最后承运方" width="120"></a-table-column>-->
              <a-table-column
                key="createAt"
                align="center"
                data-index="gpsLocation.createAt" title="最后绑定时间" width="120">
                <template slot-scope="text, record">
                  <date-time-formatter :date-time="record.gpsLocation.createAt"
                                       formatter="YYYY-MM-DD HH:mm:ss"></date-time-formatter>
                </template>
              </a-table-column>
              <a-table-column
                key="updateAt"
                align="center"
                data-index="gpsLocation.updateAt" title="最后定位时间" width="120">
                <template slot-scope="text, record">
                  <date-time-formatter :date-time="record.gpsLocation.updateAt"
                                       formatter="YYYY-MM-DD HH:mm:ss"></date-time-formatter>
                </template>
              </a-table-column>
              <!--              <a-table-column-->
              <!--                :sorter="true"-->
              <!--                key="createAt"-->
              <!--                data-index="createAt" title="创建时间" width="85">-->
              <!--                <template slot-scope="text, record">-->
              <!--                  <date-time-formatter :date-time="record.createAt"-->
              <!--                                       formatter="YYYY-MM-DD"></date-time-formatter>-->
              <!--                </template>-->
              <!--              </a-table-column>-->

              <!--              // <a-table-column type="index" label="No." width="" align="center"-->
              <!--              // :index="table_index">-->
              <!--              // prop="useStatus"-->
              <!--              // label="使用状态">-->
              <!--              // prop="inCompany"-->
              <!--              // label="是否在公司">-->
              <!--              // prop="buyStatus"-->
              <!--              // label="距公司">-->
              <!--              // prop="buyStatus"-->
              <!--              // label="最后承运方">-->
              <!--              // prop="createAt"-->
              <!--              // label="最后绑定时间">-->
              <!--              // prop="updateAt"-->
              <!--              // label="最后定位时间">-->


              <!--              <a-table-column-->
              <!--                prop="date"-->
              <!--                label="操作">-->
              <!--                <template slot-scope="text, record">-->
              <!--                  <a-button type="link" v-if="record.status === 0 && record.order.orderStatus !== 'CLOSED'"-->
              <!--                             @click="changeExpediting(record.id)" v-has="'EXPECTING-DEAL'">去处理-->
              <!--                  </a-button>-->
              <!--                  <a-button type="link" v-else-if="record.status === 1 && record.order.orderStatus !== 'CLOSED'"-->
              <!--                             v-has="'EXPECTING-DEAL'">处理中-->
              <!--                  </a-button>-->
              <!--                  <a-button type="link" v-else-if=" record.order.orderStatus === 'CLOSED'" v-has="'EXPECTING-DEAL'">-->
              <!--                    已完成-->
              <!--                  </a-button>-->
              <!--                </template>-->
              <!--              </a-table-column>-->
            </a-table>
            <!--            <div style="margin-top: 20px;text-align: center;">-->
            <!--              <a-pagination @size-change="handleSizeChange"-->
            <!--                            @current-change="handleCurrentChange"-->
            <!--                            :current-page="listQuery.page"-->
            <!--                            :page-sizes="[1,5,10]"-->
            <!--                            :page-size="listQuery.size"-->
            <!--                            layout="total, sizes, prev, pager, next, jumper"-->
            <!--                            :total="listQuery.total">-->
            <!--              </a-pagination>-->
            <!--            </div>-->
          </a-col>
        </a-row>
      </div>
    </div>
  </a-card>

</template>

<!--<script>-->

<!--import {getReceiptList, getAddress} from '../api/receipt'-->
<!--import DateTimeFormatter from '../components/DateTimeFormatter';-->


<!--async function getList() {-->
<!--    this.table.loading = true;-->
<!--    let _this = this;-->
<!--    const res = await getReceiptList({-->
<!--        page: this.table.pagination.current,-->
<!--        size: this.table.pagination.pageSize,-->
<!--        sort: this.table.sort.prop,-->
<!--        direction: 'DESC',-->
<!--        equipmentCode: this.equipmentCode,-->
<!--        isInCompany: this.isInCompany-->
<!--    });-->
<!--    if (res.code === 1200) {-->
<!--        this.table.data = res.data.list;-->
<!--        this.table.pagination.total = res.data.count;-->
<!--    }-->
<!--    this.table.loading = false;-->
<!--}-->

<!--async function search() {-->
<!--    this.listQuery.page = 1;-->
<!--    this.getList();-->
<!--}-->


<!--/**-->
<!-- * 显示条目数-->
<!-- * @param val-->
<!-- */-->
<!--function handleSizeChange(val) {-->
<!--    this.listQuery.size = val;-->
<!--    this.getList();-->
<!--}-->

<!--/**-->
<!-- * 当前页-->
<!-- * @param val-->
<!-- */-->
<!--function handleCurrentChange(val) {-->
<!--    this.listQuery.page = val;-->
<!--    this.getList();-->
<!--}-->

<!--/**-->
<!-- * 列表排列的序号-->
<!-- * @param index-->
<!-- * @returns {*}-->
<!-- */-->
<!--function table_index(index) {-->
<!--    return (this.listQuery.page - 1) * this.listQuery.size + index + 1;-->
<!--}-->

<!--function handleTableChange(pagination, filters, sorter) {-->
<!--    this.table.pagination.current = pagination.current;-->
<!--    this.table.pagination.pageSize = pagination.pageSize;-->
<!--    this.table.sort = {-->
<!--        prop: sorter.field,-->
<!--        order: sorter.order,-->
<!--    };-->
<!--    this.getList();-->
<!--}-->

<!--async function getLocationStr(item) {-->
<!--    const result = await getAddress({-->
<!--        key: 'b2483a1b5ca5c98bf1f47710d4e61d00',-->
<!--        location: item.gpsLocation.latitude.substring(0, item.gpsLocation.latitude.length > 6 ? 6 : item.gpsLocation.latitude.length) + "," +-->
<!--            item.gpsLocation.longitude.substring(0, item.gpsLocation.longitude.length > 6 ? 6 : item.gpsLocation.longitude.length)-->
<!--    });-->
<!--    console.log(result)-->
<!--    return ''-->
<!--}-->

<!--export default {-->
<!--    name: "Receipt",-->
<!--    components: {-->
<!--        DateTimeFormatter,-->
<!--    },-->
<!--    data() {-->
<!--        return {-->
<!--            table: {-->
<!--                loading: true,-->
<!--                data: [],-->
<!--                pagination: {-->
<!--                    current: 1,-->
<!--                    pageSize: 20,-->
<!--                    total: 0,-->
<!--                    showSizeChanger: true,-->
<!--                    pageSizeOptions: ['10', '20', '40', '50'],-->
<!--                    showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,-->
<!--                },-->
<!--                sort: {-->
<!--                    prop: 'createAt',-->
<!--                    order: 'descend',-->
<!--                },-->
<!--            },-->
<!--            // sort: {-->
<!--            //   prop: 'createAt',-->
<!--            //   order: 'descend',-->
<!--            // },-->
<!--            listQuery: {-->
<!--                page: 1,-->
<!--                size: 5,-->
<!--                total: 0,-->
<!--            },-->
<!--            equipmentCode: '',-->
<!--            isInCompany: '',-->
<!--            inCompanyOptions: [{-->
<!--                status: true,-->
<!--                label: '在'-->
<!--            }, {-->
<!--                status: false,-->
<!--                label: '不在'-->
<!--            }]-->
<!--        }-->
<!--    },-->
<!--    mounted() {-->
<!--        this.getList()-->
<!--    },-->
<!--    methods: {-->
<!--        handleCurrentChange,-->
<!--        handleSizeChange,-->
<!--        table_index,-->
<!--        getList,-->
<!--        search,-->
<!--        handleTableChange,-->
<!--        getLocationStr,-->
<!--    }-->
<!--}-->
<!--</script>-->

<script>

import {getReceiptList} from '../api/receipt'
import DateTimeFormatter from '../components/DateTimeFormatter';


async function getList() {
  this.table.loading = true;
  const res = await getReceiptList({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction: 'DESC',
    equipmentCode: this.equipmentCode,
    isInCompany: this.isInCompany
  });
  if (res.code === 1200) {
    this.table.data = res.data.data.list
    this.table.pagination.total = res.data.data.allPage;
  }
  this.table.loading = false;
}

async function search() {
  this.listQuery.page = 1;
  this.getList();
}


/**
 * 显示条目数
 * @param val
 */
function handleSizeChange(val) {
  this.listQuery.size = val;
  this.getList();
}

/**
 * 当前页
 * @param val
 */
function handleCurrentChange(val) {
  this.listQuery.page = val;
  this.getList();
}

/**
 * 列表排列的序号
 * @param index
 * @returns {*}
 */
function table_index(index) {
  return (this.listQuery.page - 1) * this.listQuery.size + index + 1;
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getList();
}

export default {
  name: "Receipt",
  components: {
    DateTimeFormatter,
  },
  data() {
    return {
      table: {
        loading: true,
        data: [],
        pagination: {
          current: 1,
          pageSize: 20,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        },
        sort: {
          prop: 'createAt',
          order: 'descend',
        },
      },
      // sort: {
      //   prop: 'createAt',
      //   order: 'descend',
      // },
      listQuery: {
        page: 1,
        size: 5,
        total: 0,
      },
      equipmentCode: '',
      isInCompany: '',
      inCompanyOptions: [{
        status: true,
        label: '在'
      }, {
        status: false,
        label: '不在'
      }]
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleCurrentChange,
    handleSizeChange,
    table_index,
    getList,
    search,
    handleTableChange
  }
}
</script>

<style>
  .receipt_table .ant-table-thead {
    height: 45px;
  }
  .receipt_table .ant-table-thead tr th{
    background-color: #FFF1E8;
  }
</style>
